export enum StatistikType {
    TRAININGSPLAN,
    VIDEOAUFRUF
}